import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToJpeg() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="JPEG"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-jpeg"
      gradientColors="from-purple-500 to-amber-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
